var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticClass:"custom-avatar",attrs:{"color":"accent","size":"12vh"}},[_c('img',{attrs:{"src":_vm.image}})])
}
var staticRenderFns = []

export { render, staticRenderFns }